import CarouselSlider from './carousel-slider';
import { breakpoints, gradients } from './helpers';

export { CarouselSlider as default, breakpoints, gradients };
